import logger from "../utils/logger";
export const handleCreateOwnershipTransfer = async ({
  event,
  transferScopeId,
  transferRecipientEmail,
  companyUsers,
  transferScopeType,
  request,
  setOwnershipBusy,
  setStatus,
  showStatus,
  setTransferScopeId,
  setTransferRecipientEmail,
  loadOwnershipTransfers
}) => {
  event.preventDefault();
  if (!transferScopeId || !transferRecipientEmail.trim()) return;
  setOwnershipBusy(true);
  setStatus(null);
  try {
    const recipient = companyUsers.find(item => item.email === transferRecipientEmail.trim());
    if (!recipient) {
      showStatus('error', 'Пользователь с таким email не найден.');
      setOwnershipBusy(false);
      return;
    }
    await request('/api/v1/ownership-transfers/', {
      method: 'POST',
      body: JSON.stringify({
        scope_type: transferScopeType,
        scope_id: transferScopeId,
        to_user_id: recipient.id
      })
    });
    setTransferScopeId('');
    setTransferRecipientEmail('');
    await loadOwnershipTransfers();
    showStatus('success', 'Запрос на передачу создан.');
  } catch (error) {
    logger.error(error);
    showStatus('error', `Не удалось создать запрос. ${error.message || ''}`.trim());
  } finally {
    setOwnershipBusy(false);
  }
};
export const handleOwnershipAction = async ({
  transferId,
  action,
  request,
  setOwnershipBusy,
  setStatus,
  showStatus,
  loadOwnershipTransfers
}) => {
  if (!transferId) return;
  setOwnershipBusy(true);
  setStatus(null);
  try {
    await request(`/api/v1/ownership-transfers/${transferId}/${action}`, {
      method: 'POST'
    });
    await loadOwnershipTransfers();
    showStatus('success', action === 'accept' ? 'Запрос принят.' : 'Запрос отклонён.');
  } catch (error) {
    logger.error(error);
    showStatus('error', `Не удалось выполнить действие. ${error.message || ''}`.trim());
  } finally {
    setOwnershipBusy(false);
  }
};
export const handleRemoveCabinet = async ({
  accountId,
  isOwner,
  request,
  setBusy,
  setStatus,
  showStatus,
  loadMarketplaces,
  companyId
}) => {
  if (!accountId) return;
  setBusy(true);
  setStatus(null);
  try {
    if (isOwner) {
      await request(`/api/v1/marketplaces/${accountId}`, {
        method: 'PATCH',
        body: JSON.stringify({
          is_active: false
        })
      });
      showStatus('success', 'Кабинет отключён.');
    } else {
      await request(`/api/v1/access/marketplaces/${accountId}/memberships/self`, {
        method: 'DELETE'
      });
      showStatus('success', 'Доступ удалён.');
    }
    await loadMarketplaces(companyId);
  } catch (error) {
    logger.error(error);
    showStatus('error', `Не удалось отключить кабинет. ${error.message || ''}`.trim());
  } finally {
    setBusy(false);
  }
};
export const handleCabinetInviteAction = async ({
  inviteId,
  action,
  request,
  showStatus,
  loadCabinetInvites,
  loadMarketplaces,
  companyId
}) => {
  if (!inviteId) return;
  try {
    await request(`/api/v1/invitations/me/${inviteId}/${action}`, {
      method: 'POST'
    });
    await Promise.all([loadCabinetInvites(), loadMarketplaces(companyId)]);
    showStatus('success', action === 'accept' ? 'Приглашение принято.' : 'Приглашение отклонено.');
  } catch (error) {
    logger.error(error);
    showStatus('error', 'Не удалось обработать приглашение.');
  }
};
export const handleCancelSentInvite = async ({
  inviteId,
  accountId,
  request,
  showStatus,
  loadSentInvites
}) => {
  if (!inviteId || !accountId) return;
  if (!window.confirm('Отменить приглашение?')) {
    return;
  }
  try {
    await request(`/api/v1/invitations/marketplaces/${accountId}/invitations/${inviteId}`, {
      method: 'DELETE'
    });
    await loadSentInvites(accountId);
    showStatus('success', 'Приглашение отменено.');
  } catch (error) {
    logger.error(error);
    showStatus('error', `Не удалось отменить приглашение. ${error.message || ''}`.trim());
  }
};
export const handleProjectInviteAction = async ({
  inviteId,
  action,
  request,
  showStatus,
  loadProjectInvites,
  loadWorkspaces
}) => {
  if (!inviteId) return;
  try {
    await request(`/api/v1/workspaces/invites/${inviteId}/${action}`, {
      method: 'POST'
    });
    await Promise.all([loadProjectInvites(), loadWorkspaces()]);
    showStatus('success', action === 'accept' ? 'Приглашение принято.' : 'Приглашение отклонено.');
  } catch (error) {
    logger.error(error);
    showStatus('error', 'Не удалось обработать приглашение.');
  }
};
export const handleAddMember = async ({
  event,
  accessAccountId,
  accessIdentity,
  accessForm,
  request,
  setAccessBusy,
  setStatus,
  showStatus,
  setAccessIdentity,
  loadSentInvites
}) => {
  event.preventDefault();
  if (!accessAccountId || !accessIdentity) return;
  if (!window.confirm('Пригласить сотрудника в кабинет?')) {
    return;
  }
  setAccessBusy(true);
  setStatus(null);
  try {
    await request(`/api/v1/invitations/marketplaces/${accessAccountId}/send`, {
      method: 'POST',
      body: JSON.stringify({
        email: accessIdentity.trim(),
        role: accessForm.role
      })
    });
    setAccessIdentity('');
    await loadSentInvites(accessAccountId);
    showStatus('success', 'Приглашение отправлено.');
  } catch (error) {
    logger.error(error);
    if (error.status === 409) {
      showStatus('warning', error.message || 'Приглашение уже отправлено этому пользователю.');
    } else {
      showStatus('error', `Не удалось отправить приглашение. ${error.message || ''}`.trim());
    }
  } finally {
    setAccessBusy(false);
  }
};
export const handleUpdateMember = async ({
  membershipId,
  role,
  request,
  setAccessBusy,
  setStatus,
  showStatus,
  loadMemberships,
  accessAccountId
}) => {
  if (!membershipId) return;
  setAccessBusy(true);
  setStatus(null);
  try {
    await request(`/api/v1/access/memberships/${membershipId}`, {
      method: 'PATCH',
      body: JSON.stringify({
        role
      })
    });
    await loadMemberships(accessAccountId);
    showStatus('success', 'Доступ обновлён.');
  } catch (error) {
    logger.error(error);
    showStatus('error', 'Не удалось обновить доступ.');
  } finally {
    setAccessBusy(false);
  }
};
export const handleAddProjectMember = async ({
  event,
  projectAccessWorkspaceId,
  projectAccessIdentity,
  projectAccessMode,
  projectAccessRole,
  companyUsers,
  request,
  setProjectAccessBusy,
  setStatus,
  showStatus,
  setProjectAccessIdentity,
  loadProjectInvites,
  loadWorkspaces
}) => {
  event.preventDefault();
  if (!projectAccessWorkspaceId || !projectAccessIdentity) return;
  if (!window.confirm('Добавить сотрудника в проект?')) {
    return;
  }
  setProjectAccessBusy(true);
  setStatus(null);
  try {
    const identity = projectAccessIdentity.trim();
    // Сотрудник может быть из другой компании (добавлен только в кабинет),
    // поэтому не ограничиваем список companyUsers — email резолвит бэкенд.
    let email = identity.toLowerCase();
    if (projectAccessMode === 'id') {
      const userItem = (companyUsers || []).find(item => item.id === identity);
      if (!userItem) {
        showStatus('error', 'Пользователь не найден.');
        setProjectAccessBusy(false);
        return;
      }
      email = (userItem.email || '').trim().toLowerCase();
    }
    await request(`/api/v1/workspaces/${projectAccessWorkspaceId}/invites`, {
      method: 'POST',
      body: JSON.stringify({
        email,
        role: projectAccessRole
      })
    });
    setProjectAccessIdentity('');
    await loadProjectInvites();
    if (loadWorkspaces) await loadWorkspaces();
    showStatus('success', 'Сотрудник добавлен в проект.');
  } catch (error) {
    logger.error(error);
    showStatus('error', `Не удалось добавить сотрудника. ${error.message || ''}`.trim());
  } finally {
    setProjectAccessBusy(false);
  }
};
export const handleUpdateProjectMember = async ({
  workspaceId,
  userId,
  role,
  request,
  setProjectAccessBusy,
  setStatus,
  showStatus,
  getProjectAccessMembers,
  loadWorkspaces
}) => {
  if (!workspaceId || !userId) return;
  setProjectAccessBusy(true);
  setStatus(null);
  try {
    const currentMembers = getProjectAccessMembers(workspaceId);
    const nextMembers = currentMembers.map(member => ({
      user_id: member.user_id,
      role: member.user_id === userId ? role : member.role
    }));
    await request(`/api/v1/workspaces/${workspaceId}`, {
      method: 'PATCH',
      body: JSON.stringify({
        member_ids: nextMembers
      })
    });
    await loadWorkspaces();
    showStatus('success', 'Роль обновлена.');
  } catch (error) {
    logger.error(error);
    showStatus('error', `Не удалось обновить роль. ${error.message || ''}`.trim());
  } finally {
    setProjectAccessBusy(false);
  }
};
